import React from 'react';
import { EnhancedAssumptions } from '../../types';
import { SCENARIO_OPTIONS } from '../../constants';
import { Card } from '../ui';
import { ScenarioSelector } from './ScenarioSelector';

interface GrowthAssumptionsProps {
  assumptions: EnhancedAssumptions;
  onScenarioChange: (type: string, scenario: string) => void;
  onCustomValueChange: (field: keyof EnhancedAssumptions, value: string) => void;
}

export const GrowthAssumptions: React.FC<GrowthAssumptionsProps> = ({
  assumptions,
  onScenarioChange,
  onCustomValueChange
}) => {
  return (
    <Card>
      <h2 className="text-xl font-semibold text-gray-900 mb-6">Growth Assumptions</h2>
      <div className="space-y-4">
        <ScenarioSelector
          label="Property Appreciation Scenario"
          scenarioType="propertyAppreciation"
          currentScenario={assumptions.propertyAppreciationScenario}
          currentValue={assumptions.propertyAppreciation}
          scenarioOptions={SCENARIO_OPTIONS.propertyAppreciation}
          onScenarioChange={onScenarioChange}
          onCustomValueChange={onCustomValueChange}
        />

        <ScenarioSelector
          label="Rent Growth Scenario"
          scenarioType="rentGrowth"
          currentScenario={assumptions.rentGrowthScenario}
          currentValue={assumptions.rentGrowth}
          scenarioOptions={SCENARIO_OPTIONS.rentGrowth}
          onScenarioChange={onScenarioChange}
          onCustomValueChange={onCustomValueChange}
        />

        <ScenarioSelector
          label="Stock Returns"
          scenarioType="stockReturns"
          currentScenario={assumptions.stockReturnsScenario}
          currentValue={assumptions.stockReturns}
          scenarioOptions={SCENARIO_OPTIONS.stockReturns}
          onScenarioChange={onScenarioChange}
          onCustomValueChange={onCustomValueChange}
        />

        <ScenarioSelector
          label="Bond Returns"
          scenarioType="bondReturns"
          currentScenario={assumptions.bondReturnsScenario}
          currentValue={assumptions.bondReturns}
          scenarioOptions={SCENARIO_OPTIONS.bondReturns}
          onScenarioChange={onScenarioChange}
          onCustomValueChange={onCustomValueChange}
        />
      </div>
    </Card>
  );
};